(function () {
  function money(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function compactMoney(cents) {
    var value = Number(cents) || 0;
    return money(Math.round(value / 100) * 100).replace(/\.00(?=\D*$)/, '');
  }

  function initGallery(root) {
    var image = root.querySelector('[data-product-main-image]');
    if (!image) return;
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-media-src]'));

    function show(index) {
      if (!buttons.length) return;
      index = (index + buttons.length) % buttons.length;
      var button = buttons[index];
      image.src = button.dataset.mediaSrc;
      image.removeAttribute('srcset');
      buttons.forEach(function (item) { item.classList.remove('is-active'); });
      button.classList.add('is-active');
      button.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        show(index);
      });
    });

    var previous = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', function () { show(buttons.findIndex(function (item) { return item.classList.contains('is-active'); }) - 1); });
    if (next) next.addEventListener('click', function () { show(buttons.findIndex(function (item) { return item.classList.contains('is-active'); }) + 1); });
  }

  function initProduct(root) {
    var form = root.querySelector('[data-product-form]');
    var json = root.querySelector('[data-product-variants]');
    if (!form || !json) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }

    var groups = Array.prototype.slice.call(form.querySelectorAll('[data-option-group]'));
    var price = form.querySelector('[data-product-price]');
    var compare = form.querySelector('[data-product-compare]');
    var savings = form.querySelector('[data-product-savings]');
    var submit = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-product-error]');
    var bundleButtons = Array.prototype.slice.call(form.querySelectorAll('[data-bundle-count]'));
    var upsellToggle = form.querySelector('[data-upsell-variant]');
    var upsellImage = form.querySelector('[data-upsell-image]');
    var upsellTitle = form.querySelector('[data-upsell-title]');
    var upsellPriceEl = form.querySelector('[data-upsell-price]');
    var upsellCompareEl = form.querySelector('[data-upsell-compare]');
    var upsellSavingsEl = form.querySelector('[data-upsell-savings]');
    var upsellVariants = { standard: null, king: null };
    var upsellJson = root.querySelector('[data-upsell-variants]');
    if (upsellJson) {
      try { upsellVariants = JSON.parse(upsellJson.textContent) || upsellVariants; } catch (error) {}
    }

    function selectedOptions() {
      return groups.map(function (group) {
        var selected = group.querySelector('[data-option-value].is-selected');
        return selected ? selected.dataset.optionValue : '';
      });
    }

    function getUpsellState(options, bundleCount) {
      var isKing = !!(options[0] && options[0].toLowerCase().indexOf('king') !== -1);
      var upsellVariant = isKing
        ? (upsellVariants.king || upsellVariants.standard)
        : (upsellVariants.standard || upsellVariants.king);
      var quantity = bundleCount === 4 ? 2 : 1;
      return {
        variant: upsellVariant || null,
        quantity: quantity,
        pillowCount: quantity * 2,
        isKing: isKing
      };
    }

    function renderPriceRow(variant, upsellState) {
      var extraPrice = 0;
      var extraCompare = 0;
      if (upsellToggle && upsellToggle.checked && upsellState && upsellState.variant) {
        extraPrice = (Number(upsellState.variant.price) || 0) * upsellState.quantity;
        extraCompare = (Number(upsellState.variant.compare_at_price) || Number(upsellState.variant.price) || 0) * upsellState.quantity;
      }
      var displayPrice = (Number(variant.price) || 0) + extraPrice;
      var displayCompare = (Number(variant.compare_at_price) || Number(variant.price) || 0) + extraCompare;
      price.textContent = money(displayPrice);
      if (displayCompare > displayPrice) {
        compare.hidden = false;
        compare.textContent = money(displayCompare);
        if (savings) {
          var savingsAmount = displayCompare - displayPrice;
          var savingsPercent = Math.round((savingsAmount / displayCompare) * 100);
          savings.hidden = false;
          savings.textContent = savingsPercent + '% OFF · Save ' + compactMoney(savingsAmount);
        }
      } else {
        compare.hidden = true;
        if (savings) savings.hidden = true;
      }
    }

    function syncUpsell(options, bundleCount) {
      var state = getUpsellState(options, bundleCount);
      if (upsellImage) {
        var pillowcasesMedia = root.getAttribute(bundleCount === 4 ? 'data-pillowcases-four' : 'data-pillowcases-default');
        if (pillowcasesMedia) upsellImage.src = pillowcasesMedia;
      }
      if (!upsellToggle || !state.variant) return state;
      upsellToggle.dataset.upsellVariant = String(state.variant.id);
      upsellToggle.dataset.upsellQuantity = String(state.quantity);
      if (upsellTitle) upsellTitle.textContent = 'Add ' + state.pillowCount + ' Miracle Pillowcases';
      var totalPrice = (Number(state.variant.price) || 0) * state.quantity;
      var totalCompare = (Number(state.variant.compare_at_price) || 0) * state.quantity;
      if (upsellPriceEl) upsellPriceEl.textContent = '+' + money(totalPrice);
      if (upsellCompareEl) {
        if (totalCompare > totalPrice) {
          upsellCompareEl.hidden = false;
          upsellCompareEl.textContent = money(totalCompare);
        } else {
          upsellCompareEl.hidden = true;
        }
      }
      if (upsellSavingsEl) {
        var variantPrice = Number(state.variant.price) || 0;
        var variantCompare = Number(state.variant.compare_at_price) || 0;
        if (variantCompare > variantPrice) {
          var savingsPercent = Math.round(((variantCompare - variantPrice) / variantCompare) * 100);
          upsellSavingsEl.hidden = false;
          upsellSavingsEl.textContent = 'SPECIAL PRICE! ' + savingsPercent + '% OFF';
        } else {
          upsellSavingsEl.hidden = true;
        }
      }
      return state;
    }

    function syncVariant() {
      var options = selectedOptions();
      var variant = variants.find(function (item) {
        return item.options.every(function (value, index) { return value === options[index]; });
      });
      if (!variant) return;
      form.dataset.selectedVariantId = String(variant.id);
      submit.disabled = !variant.available;
      submit.querySelector('span').textContent = variant.available ? submit.dataset.submitText : 'SOLD OUT';

      var firstThumb = root.querySelector('[data-media-src]');
      var selectedBundle = form.querySelector('[data-bundle-count].is-selected');
      var bundleCount = selectedBundle ? Number(selectedBundle.dataset.bundleCount) || 1 : 1;
      var sizeKey = options[0] && options[0].toLowerCase().indexOf('king') !== -1 ? 'king' : 'standard';
      var mappedImage = root.getAttribute('data-pillow-' + sizeKey + '-' + bundleCount);
      var selectedMedia = mappedImage || (variant.featured_image && variant.featured_image.src);
      if (firstThumb && selectedMedia) {
        firstThumb.dataset.mediaSrc = selectedMedia;
        var firstThumbImage = firstThumb.querySelector('img');
        if (firstThumbImage) firstThumbImage.src = selectedMedia;
        if (firstThumb.classList.contains('is-active')) {
          var selectedImage = root.querySelector('[data-product-main-image]');
          if (selectedImage) {
            selectedImage.src = selectedMedia;
            selectedImage.removeAttribute('srcset');
          }
        }
      }

      var upsellState = syncUpsell(options, bundleCount);
      renderPriceRow(variant, upsellState);

      bundleButtons.forEach(function (button) {
        var bundle = variants.find(function (item) {
          return item.options[0] === options[0] && item.options[1] === button.dataset.optionValue;
        });
        if (!bundle) return;
        var count = Number(button.dataset.bundleCount) || 1;
        var bundlePrice = button.querySelector('[data-bundle-price]');
        var bundleCompare = button.querySelector('[data-bundle-compare]');
        var bundleUnit = button.querySelector('[data-bundle-unit]');
        var ribbon = button.querySelector('[data-bundle-ribbon]');
        button.disabled = !bundle.available;
        if (bundlePrice) bundlePrice.textContent = money(bundle.price);
        if (bundleCompare) {
          bundleCompare.hidden = !(bundle.compare_at_price && bundle.compare_at_price > bundle.price);
          bundleCompare.textContent = money(bundle.compare_at_price);
        }
        if (bundleUnit) bundleUnit.textContent = money(Math.round(bundle.price / count)) + '/each';
        if (ribbon) {
          var label = count === 2 ? '<strong>MOST POPULAR</strong>' : '<strong>BEST DEAL</strong>';
          var bundleSavings = bundle.compare_at_price && bundle.compare_at_price > bundle.price ? bundle.compare_at_price - bundle.price : 0;
          ribbon.innerHTML = label + (bundleSavings ? ' · Save ' + compactMoney(bundleSavings) : '');
        }
      });

    }

    groups.forEach(function (group) {
      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          group.querySelectorAll('[data-option-value]').forEach(function (item) { item.classList.remove('is-selected'); });
          button.classList.add('is-selected');
          syncVariant();
        });
      });
    });

    form.querySelectorAll('.rc-gift-card').forEach(function (card) {
      var input = card.querySelector('input[type="checkbox"]');
      if (input) {
        input.addEventListener('change', function () {
          card.classList.toggle('is-selected', input.checked);
        });
        card.addEventListener('click', function (e) {
          if (e.target !== input) {
            input.checked = !input.checked;
            input.dispatchEvent(new Event('change'));
          }
        });
      }
    });

    if (upsellToggle) {
      upsellToggle.addEventListener('change', function () {
        upsellToggle.closest('.rc-upsell').classList.toggle('is-selected', upsellToggle.checked);
        syncVariant();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      errorBox.hidden = true;
      submit.disabled = true;
      submit.querySelector('span').textContent = 'ADDING…';

      var pairId = 'pw_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
      var mainItem = {
        id: Number(form.dataset.selectedVariantId),
        quantity: 1,
        properties: {
          _pairId: pairId,
          _hasFreeGift: 'true'
        }
      };
      var items = [mainItem];

      if (root.dataset.addGifts !== 'false') {
        form.querySelectorAll('.rc-gift-card').forEach(function (card) {
          var input = card.querySelector('[data-gift-variant]');
          if (input && (input.checked || card.classList.contains('is-selected'))) {
            var vId = Number(input.dataset.giftVariant);
            if (vId && !isNaN(vId)) {
              items.push({
                id: vId,
                quantity: 1,
                properties: {
                  _pairId: pairId,
                  '_free-gift': 'true',
                  _rc_offer: 'Free gift'
                }
              });
            }
          }
        });
      }

      var upsell = form.querySelector('[data-upsell-variant]:checked');
      if (upsell && upsell.dataset.upsellVariant) {
        var uId = Number(upsell.dataset.upsellVariant);
        if (uId && !isNaN(uId)) {
          items.push({
            id: uId,
            quantity: Number(upsell.dataset.upsellQuantity) || 1,
            properties: { _rc_offer: 'Complete the set' }
          });
        }
      }

      function addSingleItem(item) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [item] })
        }).then(function (res) {
          if (!res.ok) {
            if (item.properties && Object.keys(item.properties).length > 0) {
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: item.id, quantity: item.quantity }] })
              }).then(function (res2) {
                if (!res2.ok) {
                  return res2.json().then(function (err) {
                    console.warn('Item ' + item.id + ' add error:', err.description || err.message);
                    return null;
                  });
                }
                return res2.json();
              });
            }
            return res.json().then(function (err) {
              console.warn('Item ' + item.id + ' add error:', err.description || err.message);
              return null;
            });
          }
          return res.json();
        }).catch(function (err) {
          console.warn('Item ' + item.id + ' network error:', err);
          return null;
        });
      }

      function addAllItems(itemsList) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsList })
        }).then(function (response) {
          if (!response.ok) {
            var sequence = Promise.resolve();
            itemsList.forEach(function (item) {
              sequence = sequence.then(function () { return addSingleItem(item); });
            });
            return sequence;
          }
          return response.json();
        });
      }

      clearCart().then(function () {
        return addAllItems(items);
      }).then(function () {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (root.dataset.redirect === 'checkout') window.location.href = '/checkout';
        else if (root.dataset.redirect === 'cart') window.location.href = '/cart';
        else {
          submit.disabled = false;
          submit.querySelector('span').textContent = 'ADDED TO CART';
          setTimeout(function () { submit.querySelector('span').textContent = submit.dataset.submitText; }, 1800);
        }
      }).catch(function (error) {
        errorBox.textContent = error.message;
        errorBox.hidden = false;
        submit.disabled = false;
        submit.querySelector('span').textContent = submit.dataset.submitText;
      });
    });

    syncVariant();
    initGallery(root);
  }

  function clearCart() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return response.json();
    }).catch(function (error) {
      console.warn('Cart clear failed:', error);
    });
  }

  function initCartManagement() {
    clearCart();
    window.addEventListener('pageshow', function (event) {
      clearCart();
    });
  }

  function initUgc(section) {
    var track = section.querySelector('[data-ugc-track]');
    var cards = track ? Array.prototype.slice.call(track.children) : [];
    var dots = Array.prototype.slice.call(section.querySelectorAll('.rc-ugc__dots i'));
    var videos = cards.map(function (card) { return card.querySelector('video'); }).filter(Boolean);
    if (!track || !cards.length) return;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function playUgcVideo(video) {
      if (!video) return;
      videos.forEach(function (otherVideo) {
        if (otherVideo !== video) otherVideo.pause();
      });
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    }

    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var playBtn = card.querySelector('.rc-ugc__play-btn');
      if (video) {
        card.style.cursor = 'pointer';
        video.controls = false;
        video.playsInline = true;

        function updatePlaybackState() {
          var isPlaying = !video.paused && !video.ended;
          card.classList.toggle('is-playing', isPlaying);
          if (playBtn) playBtn.setAttribute('aria-label', (isPlaying ? 'Pause ' : 'Play ') + (video.getAttribute('aria-label') || 'customer testimonial video'));
        }

        card.addEventListener('click', function () {
          if (video.paused) {
            video.muted = false;
            playUgcVideo(video);
          } else if (video.muted) {
            video.muted = false;
          } else {
            video.pause();
          }
        });
        video.addEventListener('play', updatePlaybackState);
        video.addEventListener('pause', updatePlaybackState);
        video.addEventListener('ended', updatePlaybackState);
        updatePlaybackState();
      }
    });

    function autoplayFirstVideo() {
      if (prefersReducedMotion()) return;
      var firstVideo = section.querySelector('[data-ugc-autoplay]') || videos[0];
      if (!firstVideo || !firstVideo.paused) return;
      firstVideo.muted = true;
      playUgcVideo(firstVideo);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (!entry) return;
        if (entry.isIntersecting) {
          autoplayFirstVideo();
        } else {
          videos.forEach(function (video) { video.pause(); });
        }
      }, { threshold: 0.35 });
      observer.observe(section);
    }

    function update() {
      var cardWidth = cards[0].getBoundingClientRect().width + 16;
      var index = Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / cardWidth)));
      dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
    }

    var previous = section.querySelector('[data-ugc-prev]');
    var next = section.querySelector('[data-ugc-next]');
    if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * .82, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * .82, behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
  }

  function initStickyBuy() {
    var sticky = document.querySelector('[data-sticky-buy]');
    var product = document.querySelector('[data-rc-product]');
    var reasons = document.querySelector('.rc-ksp.rc-reasons');
    if (!sticky || !product || !('IntersectionObserver' in window)) return;

    var reasonsReached = !reasons;
    var productVisible = false;
    var reasonsOffset = 350;

    function update() {
      sticky.classList.toggle('is-visible', reasonsReached && !productVisible);
    }

    if (reasons) {
      function syncReasonsReached() {
        reasonsReached = reasons.getBoundingClientRect().top <= reasonsOffset;
        update();
      }
      window.addEventListener('scroll', syncReasonsReached, { passive: true });
      window.addEventListener('resize', syncReasonsReached);
      syncReasonsReached();
    }

    var productObserver = new IntersectionObserver(function (entries) {
      productVisible = entries[0].isIntersecting;
      update();
    }, { threshold: .05 });
    productObserver.observe(product);
  }

  function initAutoplayVideos() {
    var videos = document.querySelectorAll('.rc-reason__media video');
    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      var playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay was prevented; retry on user interaction
          var resume = function () {
            video.play();
            document.removeEventListener('click', resume);
            document.removeEventListener('touchstart', resume);
          };
          document.addEventListener('click', resume, { once: true });
          document.addEventListener('touchstart', resume, { once: true });
        });
      }
    });
  }

  function init() {
    document.body.classList.add('rc-ksp-page');
    initCartManagement();
    document.querySelectorAll('[data-rc-product]').forEach(initProduct);
    document.querySelectorAll('.rc-ugc').forEach(initUgc);
    initStickyBuy();
    initAutoplayVideos();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
